import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { TableUtil } from '../admintrademaster/tableUtil';
import { FireblockService } from '../fireblockvault/fireblockvault.service';
import * as moment from 'moment';
import { ProperJsonDialogComponent } from '../properJsonDialog/properjsondialog.component';
@Component({
    selector: 'app-fireblockaudit',
    templateUrl: './fireblockaudit.component.html',
    styleUrls: ['./fireblockaudit.component.css']
})
export class FireblockAuditComponent implements OnInit {
    displayedColumns = [
        'data',
        'timestamp',
        'event_type',
        'txnId',
        'sourceId',
        'sourceName',
        'assetId',
        'amount',
        'status',
        'subStatus',
        'note',
        'destinationId',
        'destinationName',
        'txHash',
        'createdAt'
    ];
    fromDate;
    toDate;
    filter: any = {};
    public selectedDate = new Date();
    public selectedDate1 = new Date();
    dataSource: MatTableDataSource<fireblockData>;
    pageSize = 25;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    constructor(private userService: UserService, private fireblockVault: FireblockService,
        public dialog: MatDialog) {
    }

    ngOnInit() {
        this.csrf();
        this.applyRefreshData();
        this.filter['fDate'] = moment(this.selectedDate).format('yyyy-MM-DD');
        this.filter['tDate'] = moment(this.selectedDate1).format('yyyy-MM-DD');
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['fDate'] = this.fromDate;
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['tDate'] = this.toDate;
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    displayProperJson(jsonData, eventType) {
        let obj = {
            jsonData: jsonData,
            eventType: eventType
        }
        this.dialog.open(ProperJsonDialogComponent, {
            width: 'auto',
            height: 'auto',
            data: obj,
        }).afterClosed().subscribe(result => {
        });
    }
    async applyRefreshData() {
        this.userService.csrf().subscribe(data => {
            this.filter['_csrf'] = data._csrf;
            this.fireblockVault.getFireblockAudit(this.filter).subscribe((success) => {
                let fireblockRes = success.data.map(fblockAudit => {
                    if (fblockAudit && fblockAudit.data) {
                        let parseData = fblockAudit.data;

                        if (fblockAudit.event_type === 'TRANSACTION_STATUS_UPDATED' || fblockAudit.event_type === 'TRANSACTION_CREATED') {
                            fblockAudit.txnId = parseData.id ? parseData.id : '-';
                        }
                        if (fblockAudit.event_type === 'VAULT_ACCOUNT_ADDED') {
                            fblockAudit.sourceId = parseData.id;
                            fblockAudit.sourceName = parseData.name;
                        } else if (fblockAudit.event_type === 'VAULT_ACCOUNT_ASSET_ADDED') {
                            fblockAudit.sourceId = parseData.accountId;
                            fblockAudit.sourceName = parseData.accountName;
                        }
                        if (parseData.source) {
                            fblockAudit.sourceId = parseData.source.id || '';
                            fblockAudit.sourceName = parseData.source.name || '';
                        }
                        if (parseData.destination) {
                            fblockAudit.destinationId = parseData.destination.id || '';
                            fblockAudit.destinationName = parseData.destination.name || '';
                        }

                        fblockAudit.assetId = parseData.assetId;
                        fblockAudit.amount = parseData.amount;
                        fblockAudit.status = parseData.status;
                        fblockAudit.subStatus = parseData.subStatus;
                        fblockAudit.note = parseData.note;
                        //fblockAudit.destinations =JSON.stringify(parseData.destinations)  || '';
                        fblockAudit.txHash = parseData.txHash;
                    }
                    fblockAudit.timestamp = moment(fblockAudit.timestamp).format('MM/DD/YY h:mm:ss A');
                    fblockAudit.createdAt = moment(fblockAudit.createdAt).format('MM/DD/YY h:mm:ss A');

                    return fblockAudit
                })
                this.dataSource = new MatTableDataSource(fireblockRes);
                this.dataSource.paginator = this.paginator
                this.dataSource.sort = this.sort;
            })
        })
    }
    async exportArray() {
        if (this.dataSource.filteredData) {
            const fireblockAudit = await this.dataSource.filteredData.map(x => ({
                EventType: x.event_type,
                TanentId: x.tenantId,
                Timestamp: x.timestamp,
                TxnId: x.txnId,
                SourceId: x.sourceId,
                SourceName: x.sourceName,
                AssetId: x.assetId,
                Amount: x.amount,
                Status: x.status,
                SubStatus: x.subStatus,
                Note: x.note,
                DestinationId: x.destinationId,
                DestinationName: x.destinationName,
                Destinations: x.destinations,
                TxHash: x.txHash,
                Data: x.data,
                CreatedAt: x.createdAt,
            }));
            TableUtil.exportArrayToExcel(fireblockAudit, "fireblockaudit");
        }

    }
    csrf() {
        this.userService.csrf().subscribe((success) => this.filter['_csrf'] = success._csrf)
    }
}
export interface fireblockData {
    event_type: string,
    tenantId: string,
    timestamp: number,
    data: string,
    txnId: string,
    sourceId: string,
    sourceName: string,
    assetId: string,
    amount: string,
    status: string,
    subStatus: string,
    note: string,
    destinationId: string,
    destinationName: string,
    destinations: string,
    txHash: string,
    createdAt: string,
}


// WEBPACK FOOTER //
// ./src/app/fireblockaudit/fireblockaudit.component.ts